export default __webpack_public_path__ + "static/media/Malaki_Portfolio5.43d0a526.webp";